import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {filter} from 'rxjs/internal/operators';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  routeName: string;

  constructor(private router: Router, private activated: ActivatedRoute) {
    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        let currentRoute = this.activated.root;
        let routeName;
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
          routeName = currentRoute.snapshot.data['translate'] || routeName;
        }
        this.routeName = routeName;
      });
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    //Unsubscribe from all events
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
